module.exports = __webpack_public_path__ + "img/17.425d482f.webp";